<template>
  <div class="ccui-app-container-detail-body">
    <el-form
      ref="form"
      :model="attrForm"
      :rules="attrRules"
      label-width="200px"
      class="ccui-form sale-box"
    >
      <el-form-item
        label="线路："
        prop="routeData"
        class="table-box"
        :rules="attrRules.routeData"
      >
        <el-button
          class="add-btn"
          :disabled="attrForm.routeData.length >= 50 || disabledEdit"
          icon="icon-ccui-add"
          type="add-button"
          @click="addRoute"
          ><span style="margin-left: 5px">添加线路</span></el-button
        >
        <div class="multiline-header sku-list">
          <div class="multiline-header-from ccui-multifunctional-table-wrapper">
            <el-table
              ref="table-route"
              class="ccui-multifunctional-table"
              :fit="true"
              border
              :data="attrForm.routeData"
              row-key="id"
              max-height="400"
            >
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="40"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column
                label="起运地"
                prop="startRouteCode"
                align="center"
                width="300"
                key="startRouteCode"
              >
                <template slot-scope="scope">
                  <span v-if="disabledEdit">
                    {{ scope.row.startRouteName[0] }}
                    {{ scope.row.startRouteName[1] }}
                  </span>
                  <el-form-item
                    :prop="'routeData.' + scope.$index + '.startRouteCode'"
                    :rules="attrRules.startRouteCode"
                    :show-message="false"
                    v-else
                  >
                    <el-input
                      :value="formatRouteInput(scope.row, 0)"
                      placeholder="请选择起运地"
                      readonly
                      @focus="chooseRoute(scope.row, 0)"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                label="目的地"
                prop="endRouteCode"
                align="center"
                width="300"
                key="endRouteCode"
              >
                <template slot-scope="scope">
                  <span v-if="disabledEdit">
                    {{ scope.row.endRouteName[0] }}
                    {{ scope.row.endRouteName[1] }}
                  </span>
                  <el-form-item
                    :prop="'routeData.' + scope.$index + '.endRouteCode'"
                    :rules="attrRules.endRouteCode"
                    :show-message="false"
                    v-else
                  >
                    <el-input
                      :value="formatRouteInput(scope.row, 1)"
                      placeholder="请选择目的地"
                      readonly
                      @focus="chooseRoute(scope.row, 1)"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column width="80" label="操作" prop="" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    :disabled="disabledEdit"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        label="车型列表："
        prop="tableData"
        :rules="attrRules.tableData"
        class="table-box"
      >
        <el-button
          class="add-btn"
          :disabled="attrForm.tableData.length >= 50 || disabledEdit"
          icon="icon-ccui-add"
          type="add-button"
          @click="addCarType"
          ><span style="margin-left: 5px">添加车型</span></el-button
        >
        <div class="multiline-header sku-list">
          <div class="multiline-header-from ccui-multifunctional-table-wrapper">
            <el-table
              ref="table"
              class="ccui-multifunctional-table sku-table"
              :fit="true"
              border
              :data="attrForm.tableData"
              row-key="id"
            >
              <el-table-column prop="spuRouteObj" label="线路" width="215">
                <template slot-scope="scope">
                  <el-form-item
                    class="el-table-form-item"
                    :prop="'tableData.' + scope.$index + '.spuRouteObj'"
                    :rules="attrRules.spuRouteObj"
                    :show-message="false"
                  >
                    <el-select
                      v-model="scope.row.spuRouteObj"
                      :disabled="disabledEdit"
                      @change="changeAttr"
                      value-key="id"
                      class="input-short"
                      placeholder="请选择"
                      value=""
                    >
                      <!-- clearable -->
                      <el-option
                        v-for="(item, index) in routeDataInCarType"
                        :label="
                          item.startRouteName.join('') +
                            '-' +
                            item.endRouteName.join('')
                        "
                        :value="item"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                v-for="item in classifyPropData"
                :prop="item.classifyPropNameId"
                :key="item.classifyPropNameId"
                :label="item.classifyPropName"
                width="155"
              >
                <template slot-scope="scope">
                  <el-form-item
                    class="el-table-form-item"
                    :prop="
                      'tableData.' +
                        scope.$index +
                        '.' +
                        item.classifyPropNameId
                    "
                    :rules="attrRules.textRule"
                    :show-message="false"
                  >
                    <el-select
                      v-model="scope.row[item.classifyPropNameId]"
                      @change="changeAttr"
                      :disabled="disabledEdit"
                      class="input-short"
                      placeholder="请选择"
                      value=""
                      value-key="classifyPropValueId"
                    >
                      <el-option
                        v-for="(n, index) in item.classifyPropValues"
                        :label="n.classifyPropValue"
                        :value="n"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="skuMats" label="运输货物类型" width="150">
                <template slot-scope="scope">
                  <!-- TODO:校验文字的样式要修改 -->
                  <el-form-item
                    class="el-table-form-item"
                    :prop="'tableData.' + scope.$index + '.skuMats'"
                    :rules="attrRules.skuMats"
                  >
                    <chooseMaterialDirectory :value.sync="scope.row.skuMats" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="tabUnitObj" label="单位" width="80">
                <template slot-scope="scope">
                  <el-form-item
                    class="el-table-form-item"
                    :prop="'tableData.' + scope.$index + '.tabUnitObj'"
                    :rules="attrRules.tabUnitObj"
                  >
                    <chooseUnit :value.sync="scope.row.tabUnitObj" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="minSaleCount" label="起运量" width="100">
                <template slot-scope="scope">
                  <el-form-item
                    class="el-table-form-item"
                    :prop="'tableData.' + scope.$index + '.minSaleCount'"
                    :rules="attrRules.textRule"
                    :show-message="false"
                  >
                    <el-input
                      v-model.trim="scope.row.minSaleCount"
                      @input="
                        formatPrice(
                          $event,
                          scope.row,
                          'blur',
                          'minSaleCount',
                          10,
                          0
                        )
                      "
                      class="input-short validate"
                      placeholder="请输入起运量"
                      clearable
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="taxCode" label="税控编码" width="160">
                <template slot-scope="scope">
                  <el-form-item
                    class="el-table-form-item"
                    :prop="'tableData.' + scope.$index + '.taxCode'"
                    :rules="attrRules.textRule"
                    :show-message="false"
                  >
                    <el-input
                      v-model="scope.row.taxCode"
                      class="input-short validate"
                      readonly
                      @click.native="showTaxRate(scope.$index)"
                      placeholder="请输入"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="taxInfo" label="税率" width="90">
                <template slot-scope="scope">
                  <el-form-item
                    class="el-table-form-item"
                    :prop="'tableData.' + scope.$index + '.taxInfo'"
                    :rules="attrRules.textRule"
                    :show-message="false"
                  >
                    <el-select
                      v-model="scope.row.taxInfo"
                      class="input-short"
                      placeholder="请选择"
                      value=""
                    >
                      <el-option
                        v-for="item in taxOptions"
                        :label="item"
                        :value="item"
                        :key="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="stockNum" label="车辆数量" width="120">
                <template slot-scope="scope">
                  <el-form-item
                    class="el-table-form-item"
                    :prop="'tableData.' + scope.$index + '.stockNum'"
                    :rules="attrRules.textRule"
                    :show-message="false"
                  >
                    <el-input
                      v-model.trim="scope.row.stockNum"
                      class="input-short validate"
                      clearable
                      placeholder="请输入车辆数量"
                      @input="
                        formatPrice(
                          $event,
                          scope.row,
                          'blur',
                          'stockNum',
                          10,
                          0
                        )
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="salePrice" label="参考价(元)" width="100">
                <template slot-scope="scope">
                  <el-form-item
                    class="el-table-form-item"
                    :prop="'tableData.' + scope.$index + '.salePrice'"
                    :rules="attrRules.textRule"
                    :show-message="false"
                  >
                    <el-input
                      v-model="scope.row.salePrice"
                      class="input-short validate"
                      placeholder="请输入"
                      @input="
                        checkInputTable('salePrice', scope.$index, 'price')
                      "
                      @change="
                        regTablePaste('salePrice', scope.$index, 'price')
                      "
                      @blur="reSetStepPrice('salePrice', scope.$index)"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                prop="date"
                label="操作"
                width="84"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    :disabled="attrForm.tableData.length >= 50 || disabledEdit"
                    type="text"
                    @click="copySku(scope.row)"
                    >复制</el-button
                  >
                  <el-button
                    size="mini"
                    type="text"
                    :disabled="disabledEdit"
                    @click="deleteSku(scope.row.id)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="适用区域：">
        <el-radio v-model="attrForm.applyArea.isAll" :label="1"
          >适用全国</el-radio
        >
        <!-- 先屏蔽“指定区域” -->
        <!-- <el-radio v-model="attrForm.applyArea.isAll" :label="0"
          >指定区域</el-radio
        >
        <template v-if="attrForm.applyArea.isAll === 0">
          <el-button
            size="mini"
            type="text"
            icon="icon-ccui-add"
            @click="addRegionSelect"
            >添加适用区域</el-button
          >
          <div
            v-if="attrForm.applyArea.isAll === 0"
            :class="
              btnIstrue == true && isOpen == false
                ? 'areaBox'
                : btnIstrue == true && isOpen == false
                ? ''
                : ''
            "
          >
            <p class="address-selected" ref="areaBox">{{ address }}</p>
          </div>
        </template>
        <span
          class="switchButton"
          v-if="
            attrForm.applyArea.isAll === 0 &&
            btnIstrue == true &&
            isOpen == false
          "
          @click="isOpen = true"
          ><i class="switchButton-text">展开</i
          ><i class="icon-ccui-next open"></i
        ></span>
        <span
          class="switchButton"
          v-if="
            attrForm.applyArea.isAll === 0 &&
            btnIstrue == true &&
            isOpen == true
          "
          @click="isOpen = false"
          ><i class="switchButton-text">收起</i
          ><i class="icon-ccui-next putAway"></i
        ></span> -->
      </el-form-item>
    </el-form>
    <regionSelector
      ref="areaSelect"
      :limitArr="limitArr"
      :dialogVisible.sync="dialogVisible"
      :checkedCitiesa="checkedCities3"
      :url="addressUrl"
      :agentId="agentId"
      @myCancel="myCancel"
    />
    <TaxRate
      :dialogTableVisibletextarea.sync="dialogTaxRate"
      @taxCodeSelected="taxCodeSelected"
    ></TaxRate>
    <concAddress
      ref="concAddress"
      :detail="editRouteData"
      @ok="handleSelectAddress"
    />
  </div>
</template>

<script>
import regionSelector from "./areaSelection";
import chooseMaterialDirectory from "./chooseMaterialDirectory";
import concAddress from "./concAddress";
import chooseUnit from "./chooseUnit";
import TaxRate from "./tax-rate";
import { getTaxRate,qrySupplierByShop,qryAddressOfFourth } from "@/views/lessor-open-shop/api.js";

import { formatPrice, formatNumber } from "@/common/index";
const refMap = ["startRoute", "endRoute"];

export default {
  name: "sale-msg",
  props: [
    "saleInfo",
    "logisticsData", // 线路列表
    "skus",
    "units",
    "selectedCheckedCities",
    "saleData",
    "checkSwitch",
    'disabledEdit'
  ],
  data() {
    return {
      orgId: "",
      limitArr: {},
      formatPrice,
      isOpen: false,
      btnIstrue: false,
      taxOptions: [],
      addressUrl:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/sra/cc/users/signup/qryAddressOfFourth",
      agentId: window.getArgs("a"),
      arr: [],
      defaultTableObj: {
        spuRouteObj: {}, //路线名称(用于和sku配对),例:湖北省武汉市-湖南省长沙市
        skuMats: [], //商品物资信息
        salePrice: "", //销售价
        stockNum: "", //库存数量
        tabUnitObj: {}, //计量单位编码对象
        taxCode: "3010102020100000000", //税控编码
        taxInfo: "9%", //税率
        minSaleCount: "" //起运量
      },
      dialogTaxRate: false,
      tableObj: {},
      address: "",
      diaRateType: "",
      supplierList: [],
      options: [],
      contractType: "",
      editRouteData: {},
      attrForm: {
        routeData: [],
        tableData: [],
        supplierObj: "",
        applyArea: {
          isAll: 1
        }
      },
      attrRules: {
        routeData: [
          { required: true, message: "请添加线路", trigger: "change" },
          { validator: this.routeDataValidate, trigger: "change" }
        ],
        startRouteCode: [
          { required: true, message: "请选择地址", trigger: "change" },
          { validator: this.lengthValidate, trigger: "change" }
        ],
        endRouteCode: [
          { required: true, message: "请选择地址", trigger: "change" },
          { validator: this.lengthValidate, trigger: "change" }
        ],
        tableData: [
          { required: true, message: "请添加车型", trigger: "change" },
          { validator: this.tableDataValidate, trigger: "change" }
        ],
        spuRouteObj: [
          { required: true, message: "请选择", trigger: "change" },
          { validator: this.emptyObjValidate, trigger: "change" }
        ],
        skuMats: [
          { required: true, message: "请选择", trigger: "change" },
          { validator: this.lengthValidate, trigger: "change" }
        ],
        tabUnitObj: [
          { required: true, message: "请选择", trigger: "change" },
          { validator: this.emptyObjValidate, trigger: "change" }
        ],
        textRule: [{ required: true, message: "请输入", trigger: "change" }]
      },
      dialogVisible: false,
      checkedCities2: [],
      checkedCities3: [],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            qryAddressOfFourth({ code: 0 }).then(response => {
              const cities = response.data.data.addressList.map((value, i) => ({
                value: value.code,
                label: value.name,
                leaf: false
              }));
              resolve(cities);
            });
          }
          if (node.level >= 1) {
            qryAddressOfFourth({ code: node.value }).then(response => {
              const areas = response.data.data.addressList.map((value, i) => ({
                value: value.code,
                label: value.name,
                leaf: value.lastFlag !== 0 || value.level == 2
              }));
              resolve(areas);
            });
          }
        }
      },
      classifyPropData: {} // 动态属性
    };
  },
  watch: {
    logisticsData(data) {
      this.attrForm.routeData = [...data];

      // 通过线路生成车型列表
      const tableData = this.skus.map(item => {
        const {
          skuId,
          id: spuId,
          carPropData,
          skuMats,
          salePrice,
          stockNum,
          taxCode,
          taxInfo,
          minSaleCount
        } = item;

        // 组装动态属性
        const classifyProps = {};
        Object.entries(carPropData).forEach(n => {
          const options = this.saleInfo.find(
            j => j.classifyPropNameId === n[0]
          );
          const value = options.propValues.find(
            j => j.classifyPropValueId === n[1]
          );
          classifyProps[n[0]] = value || {};
        });

        let tabUnitObj = {};
        if (item.unitRate) {
          const {
            basicRate,
            basicUnitCode,
            basicUnitName,
            converRate,
            converUnitCode,
            converUnitName
          } = item.unitRate;
          tabUnitObj = {
            basicUnitCode,
            basicUnitName,
            basicRate,
            converRate,
            unitCode: converUnitCode,
            unitName: converUnitName,
            units: this.units.units
          };
        }

        return {
          id: skuId,
          skuId,
          spuRouteObj: data.find(n => n.spuId === spuId) || {}, //路线名称(用于和sku配对),例:湖北省武汉市-湖南省长沙市
          skuMats, //商品物资信息
          salePrice, //销售价
          stockNum, //库存数量
          tabUnitObj,
          taxCode, //税控编码
          taxInfo, //税率
          minSaleCount, //起运量
          ...classifyProps
        };
      });
      this.attrForm.tableData = tableData;
    },
    "attrForm.routeData"() {
      this.$refs["form"].validateField(["routeData"]);
    },
    "attrForm.tableData.length"() {
      this.$refs["form"].validateField(["tableData"]);
    },
    "attrForm.tableData": {
      handler(data) {
        // 过滤掉没有选择线路&车型&车长的数据
        const restData = data.filter(item => {
          // 如果当前数据的线路+车型+车长都有值，就生成attr（中文title）
          const needAttr =
            this.classifyPropKeys.every(n => item[n]) &&
            !this.IsEmpty(item.spuRouteObj);
          if (needAttr) {
            const { startRouteName, endRouteName } = item.spuRouteObj;
            const routeName =
              startRouteName.join("") + "-" + endRouteName.join("");
            const classifyName = this.classifyPropKeys.map(
              n => item[n].classifyPropValue
            );
            const attr = [routeName, ...classifyName].join("|");
            item.attr = attr;
            item.propNameJoin = attr;
          }
          return needAttr;
        });
        const result = restData.map(({ attr }) => attr);
        this.$emit("skuChecked", result);
      },
      deep: true
    },
    "saleData.applyArea"(data) {
      this.attrForm.applyArea = { ...data, isAll: 1 };
      // let objAreas = data.areas;
      // objAreas.map(item => {
      //   item.cityName = item.name;
      //   item.checked = true;
      // });
      // this.address = data.address;
      // this.checkedCities3 = objAreas;
      // objAreas.forEach(item => {
      //   this.checkedCities2.push(item.pcode ? item.pcode2 : item.code);
      // });
      // this.$nextTick(function() {
      //   if (this.attrForm.applyArea.isAll === 0) {
      //     this.offsetHeight = this.$refs.areaBox.offsetHeight;
      //     if (this.offsetHeight > 90) {
      //       this.btnIstrue = true;
      //     } else {
      //       this.btnIstrue = false;
      //     }
      //   }
      // });
    },
    saleInfo(data) {
      // 获取动态属性
      const keys = {};
      data.forEach(item => {
        keys[item.classifyPropNameId] = item;
      });
      this.classifyPropData = keys;
    }
  },
  computed: {
    classifyPropKeys() {
      return this.saleInfo.map(item => item.classifyPropNameId);
    },

    routeDataInCarType() {
      return this.attrForm.routeData.filter(
        item => item.startRouteCode.length && item.endRouteCode.length
      );
    }
  },
  components: {
    concAddress,
    chooseMaterialDirectory,
    chooseUnit,
    regionSelector,
    TaxRate
  },
  created() {
    // this.qrySupplierByShop();
  },
  mounted() {
    this._getTaxRate();
  },
  methods: {
    addRoute() {
      const data = {
        id: new Date().getTime(),
        startRouteName: [],
        startRouteCode: [],
        endRouteName: [],
        endRouteCode: []
      };
      this.attrForm.routeData.push(data);
    },
    chooseRoute(data, type) {
      this.editRouteData = {
        id: data.id,
        type,
        areaName: data[refMap[type] + "AreaName"] || "",
        areaId: data[refMap[type] + "AreaId"] || "",
        provinceName: data[refMap[type] + "Name"][0],
        provinceId: data[refMap[type] + "Code"][0],
        cityName: data[refMap[type] + "Name"][1],
        cityId: data[refMap[type] + "Code"][1]
      };
      this.$nextTick(() => {
        this.$refs.concAddress.init();
      });
    },
    handleSelectAddress(value) {
      const {
        deliveryAreaName,
        deliveryAreaCode,
        provinceName,
        province,
        cityName,
        city
      } = value;
      const { id, type } = this.editRouteData;
      const routeData = [...this.attrForm.routeData];
      routeData.some(item => {
        if (item.id === id) {
          item[refMap[type] + "AreaName"] = deliveryAreaName;
          item[refMap[type] + "AreaId"] = deliveryAreaCode;
          item[refMap[type] + "Name"] = [provinceName, cityName];
          item[refMap[type] + "Code"] = [province, city];
        }
        return item.id === id;
      });
      this.attrForm.routeData = [...routeData];
    },
    formatRouteInput(data, type) {
      return (
        data[refMap[type] + "Name"][0] + data[refMap[type] + "Name"][1] || ""
      );
    },
    handleDelete(index) {
      const curRoute = this.attrForm.routeData[index];
      // 当前了路线已被选，则无法被删除
      console.log(
        "🚀 ~ handleDelete ~ this.attrForm.tableData:",
        this.attrForm.tableData
      );
      const isChoosed = this.attrForm.tableData.some(
        item => item.spuRouteObj.id === curRoute.id
      );
      if (isChoosed) {
        return this.$message({
          message: "当前线路已选用",
          type: "error",
          ccuiCustom: true,
          showClose: true
        });
      }
      this.attrForm.routeData.splice(index, 1);
      this.$forceUpdate();
    },
    changeAttr() {
      this.$nextTick(() => {
        this.$refs["form"].validateField(["tableData"]);
      });
    },
    addCarType() {
      const {
        basicUnitCode,
        basicUnitName,
        measuringRatioAfter,
        measuringRatioBefore,
        units
      } = this.units;
      const defaultTableObj = {
        ...this.defaultTableObj,
        id: new Date().getTime(),
        tabUnitObj: {
          basicUnitCode,
          basicUnitName,
          basicRate: measuringRatioBefore || "1",
          converRate: measuringRatioAfter || "1",
          unitCode: basicUnitCode,
          unitName: basicUnitName,
          units
        }
      };
      this.attrForm.tableData.push(defaultTableObj);
    },
    qrySupplierByShop(val) {
      this.attrForm.supplierObj = {
          value: val.supplierCode,
          label: val.supplierName
        };


      // var obj = {};
      // if (this.$route.query.contractPurId == undefined) {
      //   obj.contractId = this.$route.params.contractPurId;
      // } else {
      //   obj.contractId = this.$route.query.contractPurId;
      // }
      // obj.shopId = shopId || "";
      // qrySupplierByShop(obj).then(res => {
      //   this.supplierList = res.data.data.list;
      //   this.contractType = res.data.data.contractType;
      //   this.attrForm.supplierObj = {
      //     value: this.supplierList[0].supplierCode,
      //     label: this.supplierList[0].supplierName
      //   };
      // });
    },
    _getTaxRate() {
      getTaxRate({}).then(res => {
        this.taxOptions = res.data.data.taxOptions.filter(item => {
          return (
            item != "14%" && item != "15%" && item != "18.9%" && item != "20%"
          );
        });
      });
    },
    myCancel(addressSelected) {
      addressSelected = addressSelected.filter(i => i);
      if (addressSelected.length && addressSelected[0].cityName === "全国") {
        this.attrForm.applyArea.isAll = 1;
        let that = this;
        let address = [];
        that.checkedCities2 = [];
        this.address = address.join("，");
        that.checkedCities3 = [];
        this.btnIstrue = false;
        this.isOpen = false;
        return;
      }
      this.address = [];
      let that = this;
      let address = [];
      that.checkedCities2 = [];
      that.checkedCities3 = addressSelected;
      addressSelected.forEach(item => {
        address.push(item.cityName);
        that.checkedCities2.push(item.pcode ? item.pcode2 : item.code);
      });
      that.checkedCities2 = that.checkedCities2.filter(i => i);
      this.address = address.filter(i => i).join("，");
      this.btnIstrue = false;
      this.isOpen = false;
      this.$nextTick(function() {
        if (this.attrForm.applyArea.isAll === 0) {
          this.offsetHeight = this.$refs.areaBox.offsetHeight;
          if (this.offsetHeight > 90) {
            this.btnIstrue = true;
          } else {
            this.btnIstrue = false;
          }
        }
      });
    },
    taxCodeSelected(row) {
      this.attrForm.tableData[this.diaRateType].taxCode = row.mergeCode;
      this.attrForm.tableData[this.diaRateType].taxInfo = row.vatRate;
    },
    checkInputTable(name, index, type) {
      this.attrForm.tableData[index][name] = this.dealInputVal(
        this.attrForm.tableData[index][name],
        type,
        this.attrForm.tableData[index],
        name
      );
    },
    regTablePaste(name, index, type) {
      let reg = "";
      if (type === "price") {
        reg = /^(\d{0,8})(\.(\d{0,2}))?$/g;
      } else {
        reg = /^[1-9]\d{0,5}?$/g;
      }
      if (name === "stockNum") {
        reg = /^[0-9]\d{0,5}?$/g;
      }
      if (!reg.test(this.attrForm.tableData[index][name])) {
        this.attrForm.tableData[index][name] = "";
      }
    },
    // table单元格失焦事件
    reSetStepPrice(key, index, e) {
      if (
        ["", null, undefined, "-", ".", "-.", ".-", "-0"].includes(
          this.attrForm.tableData[index][key]
        )
      ) {
        this.attrForm.tableData[index][key] = "";
      } else {
        this.attrForm.tableData[index][key] = formatNumber(
          this.attrForm.tableData[index][key],
          2
        );
      }
    },
    dealInputVal(value, type, row, name) {
      return formatPrice("", row, "", name, 8, 2);
    },
    copySku(data) {
      const result = {
        ...data,
        id: new Date().getTime()
      };
      this.attrForm.tableData.push(result);
    },
    deleteSku(id) {
      const resData = this.attrForm.tableData.filter(item => item.id !== id);
      this.attrForm.tableData = [...resData];
    },
    addRegionSelect() {
      this.dialogVisible = true;
    },
    showTaxRate(type) {
      this.diaRateType = type;
      this.dialogTaxRate = true;
    },
    submitValid() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
            this.$message({
              message: '请完善车型列表信息',
              type: "error",
              duration: 3000,
              ccuiCustom: true,
              showClose: true,
              offset: document.body.clientHeight / 2 - 21,
            });
            return false;
          }
      });
    },
    routeDataValidate(_, value, callback) {
      if (!value.length) {
        callback(new Error("请添加线路"));
      } else {
        callback();
      }
    },
    lengthValidate(_, value, callback) {
      if (!value.length) {
        callback(new Error("请选择"));
      } else {
        callback();
      }
    },
    tableDataValidate(_, value, callback) {
      const attrs = value
        .map(({ attr }) => attr)
        .filter(item => item !== undefined);
      const newAttrs = [...new Set(attrs)].filter(item => item !== undefined);
      if (!value.length) {
        callback(new Error("请添加车型"));
      } else if (
        attrs.length &&
        attrs.length > 1 &&
        attrs.length !== newAttrs.length
      ) {
        callback(new Error("线路、车型、车长重复填写"));
      } else {
        callback();
      }
    },
    emptyObjValidate(_, value, callback) {
      if (this.IsEmpty(value)) {
        callback(new Error("请选择"));
      } else {
        callback();
      }
    },
    IsEmpty(object) {
      for (var name in object) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.sale-box {
  /deep/ .table-box {
    margin-bottom: 30px;
    > .el-form-item__content {
      width: 70% !important;
    }
    .add-btn.is-disabled {
      .icon-ccui-add {
        color: #c0c4cc;
      }
      span {
        color: #c0c4cc;
      }
    }
    tbody tr td:first-child .cell {
      padding-right: 10px !important;
    }
    .cell {
      padding-right: 10px !important;
      .el-form-item__content {
        width: 100% !important;
      }
    }
  }
}
/deep/ .tax-select {
  padding-left: 0;
  span {
    &.el-input__suffix {
      right: 15px;
      input {
        border-radius: 2px;
      }
    }
  }
}
/deep/ .el-select {
  .el-input {
    &.is-disabled {
      .el-input__inner {
        padding-left: 10px;
      }
    }
  }
}
.el-form-item__label {
  .text-flow {
    display: inline-block;
    width: 110px;
    /*overflow:hidden;//超出一行文字自动隐藏*/
    /*text-overflow:ellipsis;//文字隐藏后添加省略号*/
    /*white-space:nowrap;//强制不换行*/
  }
}
.address-selected {
  color: #4a4a4a;
}
/deep/ .ccui-multifunctional-table-wrapper .el-table td .stepPrice {
  height: 25px;
  border-color: #ccc;
  span {
    color: #4a4a4a;
  }
}
.fill-btn {
  /deep/ .el-form-item__content {
    text-align: right;
  }
  .el-button {
    background: #0089ef;
    border: none;
    &:active {
      background: #007bd7;
    }
  }
}
.required-red-icon {
  color: #f56c6c;
  position: absolute;
  top: 0px;
  left: 5px;
}
.table-header-input {
  /deep/ input {
    height: 22px;
  }
  /deep/ input::-webkit-input-placeholder {
    color: #4a4a4a;
  }
}
.el-table-form-item {
  /deep/ .el-form-item__content {
    line-height: 36px !important;
  }
  &.is-error {
    /deep/ .input-short {
      input {
        border: 1px solid #f56c6c !important;
      }
    }
  }
}
.el-weight-unit {
  /deep/ .input-long {
    width: 365px;
  }
  /deep/ .el-input--suffix .el-input__inner {
    padding-right: 16px;
    width: 45px;
  }
}
.weight-input {
  width: 68% !important;
  /deep/ .el-input__inner {
    background: #fff !important;
    border: 1px solid #dcdfe6 !important;
  }
}
.weight-select {
  width: 30%;
  height: 22px;
  /deep/ .el-input--suffix {
    .el-input__inner {
      height: 22px;
      width: 32px;
      padding-right: 2px;
      padding-left: 2px;
    }
    .el-input__suffix {
      right: 0;
    }
  }
}
/deep/ .weight-select-header {
  display: inline-block;
  /*float:left;*/
  /*margin-right:7px;*/
  width: 30%;
  padding: 0;
  .el-input--suffix {
    padding: 0;
  }
  input {
    padding-right: 0;
    padding-left: 2px;
  }
  .el-input__suffix {
    right: 2px;
  }
}
.multiline-header {
  /deep/ .el-input {
    line-height: 37px !important;
  }
}
.multiline-header .multiline-header-from .el-table /deep/ th {
  padding: 0px 0;
  font-weight: 400;
}
.multiline-header .multiline-header-from .el-table /deep/ th .cell {
  line-height: 1;
}
.sku-list {
  /deep/ .el-table--border td {
    border-right: 1px solid #ebeef5;
  }
  /deep/ .el-table--border th {
    border-right: 1px solid #ebeef5;
  }
  /deep/ .el-table__row td {
    border-right: 1px solid #ebeef5 !important;
  }
  /deep/ .el-table__row .cell {
    height: auto !important;
    .el-form-item {
      margin-bottom: 0;
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
  /deep/ .el-input__inner {
    height: 22px;
    line-height: 22px;
  }
  .multiline-header-from {
    td {
      .input-short {
        /deep/ .el-input__inner {
          background: #f1f1f1;
          border: none;
          height: 22px;
          border-radius: 2px;
        }
      }
    }
  }
}
.unit {
  color: #4a4a4a;
}
.unit-change {
  color: #0089ef;
  margin-left: 10px;
  cursor: pointer;
}
.input-title {
  margin-bottom: 10px;
  span {
    display: inline-block;
    text-align: center;
    font-size: 14px;
    &:first-child {
      width: 32%;
      margin-left: 30px;
    }
    &:nth-child(2) {
      width: 60%;
    }
  }
}
.dialog-unit {
  .el-input {
    width: 145px;
  }
  .el-select {
    width: 145px;
  }
}
.line-input {
  margin: 0 10px;
  color: #9b9b9b;
}
.point-input {
  width: 30px;
  text-align: center;
  float: left;
  color: #9b9b9b;
}
/deep/ .el-dialog {
  width: 500px;
}
.sku-set-price {
  margin-bottom: 10px;
}
.metering-dialog {
  .el-input,
  .el-select {
    width: 160px;
  }

  .dialog-icon {
    margin: 0 20px;
  }

  .dialog-span {
    margin: 0 23px;
  }
}
.tips {
  // color: $--breadcrumb-separator-color;
  font-size: 11px;
  margin-right: 350px;
  color: #ff142f;
}
/deep/ .el-input.is-disabled {
  background-color: rgba(255, 255, 255, 0);
}
/deep/ .applicableArea .el-dialog {
  min-width: 1180px !important;
}
.switchButton {
  display: inline-block;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #0089ef;
  cursor: pointer;
}
.switchButton-text {
  text-decoration: underline;
  font-style: normal;
}
.open {
  display: inline-block;
  transform: rotate(90deg);
  -ms-transform: rotate(90deg); /* IE 9 */
  -moz-transform: rotate(90deg); /* Firefox */
  -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
  -o-transform: rotate(90deg);
  margin-left: 4px;
}
.putAway {
  display: inline-block;
  transform: rotate(-90deg);
  -ms-transform: rotate(-90deg); /* IE 9 */
  -moz-transform: rotate(-90deg); /* Firefox */
  -webkit-transform: rotate(-90deg); /* Safari 和 Chrome */
  -o-transform: rotate(-90deg);
  margin-left: 4px;
}
.areaBox {
  height: 90px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
